import { render, staticRenderFns } from "./AfterList.vue?vue&type=template&id=b5dee9a8&scoped=true"
import script from "./AfterList.vue?vue&type=script&lang=js"
export * from "./AfterList.vue?vue&type=script&lang=js"
import style0 from "./AfterList.vue?vue&type=style&index=0&id=b5dee9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dee9a8",
  null
  
)

export default component.exports